import React from 'react';
import styled from 'styled-components';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { analytics } from '../../services/analytics';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';

interface PayPalButtonProps {
  amount: number;
  currency?: string;
  onSuccess: (details: any) => void;
  onError: (error: any) => void;
  onCancel: () => void;
  disabled?: boolean;
  cartItems?: any[];
  promoCode?: string;
  promoDiscount?: number;
}

const PayPalContainer = styled.div`
  width: 100%;
  margin-top: ${props => props.theme.spacing.medium};
  min-height: 60px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #f9f9f9;
`;

const ErrorMessage = styled.div`
  color: red;
  padding: 10px;
  text-align: center;
  font-size: 14px;
`;

const PayPalButton: React.FC<PayPalButtonProps> = ({
  amount,
  currency = 'USD',
  onSuccess,
  onError,
  onCancel,
  disabled = false,
  cartItems = [],
  promoCode,
  promoDiscount
}) => {
  const { user } = useAuth();

  const createOrder = async (data: any, actions: any) => {
    try {
      console.log('=== CREATE ORDER DEBUG ===');
      console.log('user:', user);
      console.log('amount:', amount);
      console.log('promoCode:', promoCode);
      console.log('promoDiscount:', promoDiscount);
      
      // 1. Crear orden en backend antes de PayPal
      const orderData = {
        userId: user?.userId,
        montoTotal: amount,
        descuentoPorcentaje: promoDiscount,
        codigoDescuento: promoCode
      };

      console.log('orderData a enviar:', orderData);
      
      const response = await axios.post('https://canvasoft.com:8487/canvamanager/market/compra', orderData);
      console.log('response del backend:', response.data);
      const { compraId } = response.data;

      // Track checkout initiation
      analytics.beginCheckout(cartItems, amount);
      
      // 2. Crear orden PayPal con ID de compra en custom_id
      return actions.order.create({
        purchase_units: [{
          amount: {
            value: amount.toString(),
            currency_code: currency
          },
          description: 'Canvasoft Images Purchase',
          custom_id: compraId.toString() // ID de compra para callback
        }],
        application_context: {
          return_url: `https://canvasoft.com/payment-success?compraId=${compraId}`,
          cancel_url: 'https://canvasoft.com/cart',
          landing_page: 'LOGIN',
          user_action: 'PAY_NOW',
          shipping_preference: 'NO_SHIPPING'
        }
      });
    } catch (error) {
      console.error('=== ERROR CREANDO ORDEN ===');
      console.error('Error completo:', error);
      if (axios.isAxiosError(error)) {
        console.error('Error response:', error.response?.data);
        console.error('Error status:', error.response?.status);
      }
      console.error('========================');
      throw error;
    }
  };

  const onApprove = async (data: any, actions: any) => {
    try {
      console.log('=== PAYPAL APPROVE DEBUG ===');
      console.log('PayPal data:', data);
      
      const details = await actions.order.capture();
      console.log('PayPal details:', details);
      
      // Obtener compraId del custom_id
      const compraId = details.purchase_units[0].custom_id;
      console.log('compraId extraído:', compraId);
      
      // Confirmar pago en backend
      const confirmData = {
        paypalOrderId: details.id,
        paypalStatus: details.status,
        paypalDetails: details
      };
      console.log('Confirmando pago con data:', confirmData);
      
      await axios.post(`https://canvasoft.com:8487/canvamanager/market/compra/${compraId}/confirmar`, confirmData);
      console.log('Pago confirmado exitosamente');
      
      onSuccess(details);
    } catch (error) {
      console.error('=== ERROR CONFIRMANDO PAGO ===');
      console.error('Error completo:', error);
      if (axios.isAxiosError(error)) {
        console.error('Error response:', error.response?.data);
      }
      console.error('========================');
      onError(error);
    }
  };

  const handleError = (error: any) => {
    console.error('PayPal Error:', error);
    onError(error);
  };

  const initialOptions = {
    clientId: "AZ-U69Xu85NrpuokdK4Lr9i1746lT2bd5WtOd9cny4YdoMAWoCV_VNTeXZkBj9OIC-GRIFizeQzj1Qs3",
    currency: currency,
    intent: "capture" as const,
    components: "buttons",
    "data-page-type": "checkout",
    environment: "production" as const // Modo producción para pagos reales
  };

  return (
    <PayPalContainer>
      <PayPalScriptProvider 
        options={initialOptions}
      >
        <PayPalButtons
          disabled={disabled}
          style={{
            layout: 'vertical',
            color: 'gold',
            shape: 'rect',
            label: 'paypal',
            height: 50
          }}
          createOrder={createOrder}
          onApprove={onApprove}
          onError={handleError}
          onCancel={onCancel}
          forceReRender={[amount]}
        />
      </PayPalScriptProvider>
    </PayPalContainer>
  );
};

export default PayPalButton;